webpackJsonp([64],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

var _vanillaModal = __webpack_require__(133);

var _vanillaModal2 = _interopRequireDefault(_vanillaModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailDisclaimerModal = function (_Component) {
  _inherits(EmailDisclaimerModal, _Component);

  function EmailDisclaimerModal(el, config) {
    _classCallCheck(this, EmailDisclaimerModal);

    var _this = _possibleConstructorReturn(this, (EmailDisclaimerModal.__proto__ || Object.getPrototypeOf(EmailDisclaimerModal)).call(this, el, config));

    _this.modal = new _vanillaModal2.default();
    return _this;
  }

  _createClass(EmailDisclaimerModal, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        modal: '#wh-email-disclaimer-modal',
        $modalContainer: $('.modal'),
        $acceptBtn: $('.wh-email-disclaimer-modal__accept'),
        $cancelBtn: $('.wh-email-disclaimer-modal__cancel')
      };
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.$el.on('click', 'a[href^="mailto:"]', this.onLinkClick.bind(this));
      this.dom.$acceptBtn.on('click', this.onMailTo.bind(this));
      this.dom.$cancelBtn.on('click', this.onCancel.bind(this));
    }
  }, {
    key: 'onLinkClick',
    value: function onLinkClick(e) {
      var $target = $(e.currentTarget);
      // Do nothing if it's the the accept button on the modal
      if ($target.hasClass('wh-email-disclaimer-modal__accept')) {
        return;
      }

      var email = $target.attr('href').toLowerCase();
      if (email.endsWith('wilmerhale.com')) {
        e.preventDefault();
        this.dom.$acceptBtn.attr('href', email);

        if (!email) return;

        this.modal.open(this.dom.modal);
      }
    }
  }, {
    key: 'onMailTo',
    value: function onMailTo() {
      this.modal.close();
    }
  }, {
    key: 'onCancel',
    value: function onCancel(e) {
      e.preventDefault();
      this.modal.close();
    }
  }]);

  return EmailDisclaimerModal;
}(_component2.default);

exports.default = EmailDisclaimerModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

var _vanillaModal = __webpack_require__(133);

var _vanillaModal2 = _interopRequireDefault(_vanillaModal);

var _template2 = __webpack_require__(91);

var _template3 = _interopRequireDefault(_template2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoModal = function (_Component) {
  _inherits(VideoModal, _Component);

  function VideoModal(el, config) {
    _classCallCheck(this, VideoModal);

    var _this = _possibleConstructorReturn(this, (VideoModal.__proto__ || Object.getPrototypeOf(VideoModal)).call(this, el, config));

    _this.modal = new _vanillaModal2.default({
      onBeforeClose: function onBeforeClose() {
        return _this.removeModalContent();
      }
    });
    return _this;
  }

  _createClass(VideoModal, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $body: $('body'),
        $iframe: $('#wh-video-modal iframe'),
        modal: '#wh-video-modal'
      };
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.dom.$body.on('click', '.wh-video-trigger', this.onVideoTriggered.bind(this));
    }
  }, {
    key: 'onVideoTriggered',
    value: function onVideoTriggered(e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      var videoId = $target.data('video-id');
      var accountId = $target.data('account-id');
      var playerId = $target.data('player-id');
      var hasVimeoVideo = $target.data('has-vimeo-video');
      var vimeoVideoUrl = $target.data('vimeo-video-url');
      var vimeoVideoThumbnaillUrl = $target.data('vimeo-video-thumbnail-url');

      if (!videoId) return;

      this.openModal({
        videoId: videoId,
        accountId: accountId,
        playerId: playerId,
        hasVimeoVideo: hasVimeoVideo,
        vimeoVideoUrl: vimeoVideoUrl,
        vimeoVideoThumbnaillUrl: vimeoVideoThumbnaillUrl
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(data) {
      var tpl = (0, _template3.default)(this.config.template)({
        data: data
      });

      this.dom.$body.append(tpl);

      this.modal.open(this.dom.modal);
      this.dom.$body.addClass('video-modal');

      // Modal Container
      var modalContainer = this.modal.dom.modal;
      var focusableElements = modalContainer.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
      var firstFocusableElement = focusableElements[0];

      firstFocusableElement.focus();
    }
  }, {
    key: 'removeModalContent',
    value: function removeModalContent() {
      this.dom.$body.removeClass('video-modal');
      $(this.dom.modal).remove();
    }
  }]);

  return VideoModal;
}(_component2.default);

exports.default = VideoModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

var _vanillaModal = __webpack_require__(133);

var _vanillaModal2 = _interopRequireDefault(_vanillaModal);

var _template2 = __webpack_require__(91);

var _template3 = _interopRequireDefault(_template2);

var _forEach2 = __webpack_require__(211);

var _forEach3 = _interopRequireDefault(_forEach2);

var _perfectScrollbar = __webpack_require__(593);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExcerptsModal = function (_Component) {
  _inherits(ExcerptsModal, _Component);

  function ExcerptsModal(el, config) {
    _classCallCheck(this, ExcerptsModal);

    var _this = _possibleConstructorReturn(this, (ExcerptsModal.__proto__ || Object.getPrototypeOf(ExcerptsModal)).call(this, el, config));

    _this.modal = new _vanillaModal2.default({
      onBeforeOpen: function onBeforeOpen() {
        return _this.onOpenModal();
      },
      onBeforeClose: function onBeforeClose() {
        return _this.removeModalContent();
      }
    });
    return _this;
  }

  _createClass(ExcerptsModal, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $body: $('body'),
        modal: '.wh-excerpts-modal'
      };

      this.bodyYPosition = 0;
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.dom.$body.on('click', '.wh-excerpts-trigger', this.openModal.bind(this));
    }
  }, {
    key: 'openModal',
    value: function openModal(e) {
      e.preventDefault();

      this.onLoadData({
        id: $(e.currentTarget).data('book-id')
      });
    }
  }, {
    key: 'onOpenModal',
    value: function onOpenModal() {
      this.bodyYPosition = $(window).scrollTop() * -1;
      $('body').css('top', this.bodyYPosition + 'px');
    }
  }, {
    key: 'removeModalContent',
    value: function removeModalContent() {
      this.scrollbarContent.destroy();
      this.scrollbarList.destroy();
      $(this.dom.modal).remove();
      $(window).scrollTop(this.bodyYPosition);
    }
  }, {
    key: 'goToMenu',
    value: function goToMenu(e) {
      e.preventDefault();
      this.dom.$modalContent.removeClass('view-content');
    }
  }, {
    key: 'goToContent',
    value: function goToContent(e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      var itemKey = $target.data('excerpt-key');

      this.dom.$menuItem.removeClass('active');
      $target.parent().addClass('active');
      this.dom.$modalContent.addClass('view-content');

      this.dom.$content.html('<h2 class="wh-excerpts-modal__title">' + this.data[itemKey].Title + '</h2>' + this.data[itemKey].Content);
    }
  }, {
    key: 'onLoadData',
    value: function onLoadData(params) {
      this.renderData(params).catch(function (err) {
        console.error('There was an issue getting your results', err);
      });
    }
  }, {
    key: 'renderData',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var tpl, $modalContent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getData(params);

              case 2:
                this.data = _context.sent;
                tpl = (0, _template3.default)(this.config.template, { imports: { _forEach: _forEach3.default } })({
                  data: this.data
                });


                this.dom.$body.append(tpl);

                $modalContent = $('.wh-excerpts-modal__content');


                this.dom = _extends({}, this.dom, {
                  $modalContent: $modalContent,
                  $backBtn: $modalContent.find('.wh-excerpts-modal__btn-back'),
                  $menuItem: $modalContent.find('.wh-excerpts-modal-menu__item'),
                  $content: $modalContent.find('.wh-excerpts-modal__main')
                });

                this.dom.$backBtn.on('click', this.goToMenu.bind(this));
                this.dom.$modalContent.on('click', '.wh-excerpts-modal-menu__item a', this.goToContent.bind(this));

                this.scrollbarContent = new _perfectScrollbar2.default('.wh-excerpts-modal__main');
                this.scrollbarList = new _perfectScrollbar2.default('.wh-excerpts-modal-menu');

                this.modal.open('#wh-excerpts-modal');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function renderData(_x) {
        return _ref.apply(this, arguments);
      }

      return renderData;
    }()
  }, {
    key: 'getData',
    value: function getData(params) {
      return $.getJSON(this.config.endpoint, _extends({}, params));
    }
  }]);

  return ExcerptsModal;
}(_component2.default);

exports.default = ExcerptsModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookieUseDisclaimer = function (_Component) {
  _inherits(CookieUseDisclaimer, _Component);

  function CookieUseDisclaimer(el, config) {
    _classCallCheck(this, CookieUseDisclaimer);

    return _possibleConstructorReturn(this, (CookieUseDisclaimer.__proto__ || Object.getPrototypeOf(CookieUseDisclaimer)).call(this, el, config));
  }

  _createClass(CookieUseDisclaimer, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $closeBtn: this.$el.find('.wh-cookie-use-disclaimer__btn-close')
      };

      this.cssClasses = {
        close: 'close'
      };
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.dom.$closeBtn.on('click touch', this.onClose.bind(this));
    }
  }, {
    key: 'onClose',
    value: function onClose(e) {
      e.preventDefault();

      this.$el.addClass(this.cssClasses.close);

      $.post(this.config.endpoint, {
        Guid: this.$el.data('guid')
      });
    }
  }]);

  return CookieUseDisclaimer;
}(_component2.default);

exports.default = CookieUseDisclaimer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

__webpack_require__(213);

var _gsap = __webpack_require__(90);

__webpack_require__(210);

__webpack_require__(599);

var _helpers = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(el, config) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, el, config));

    _this.init();
    return _this;
  }

  _createClass(Header, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $headerNav: this.$el.find('.wh-header-navigation'),
        $headerNavBar: this.$el.find('.wh-header-navigation__wrapper'),
        $searchBtn: this.$el.find('.wh-header-navigation__search-icon'),
        $searchInput: this.$el.find('.wh-search-box__field'),
        $navLinks: this.$el.find('.wh-header-navigation__links'),
        $searchBox: this.$el.find('.wh-search-box'),
        $predictiveResults: this.$el.find('.wh-predictive-search'),
        $burgerBtn: this.$el.find('.wh-header-navigation__burger'),
        $document: $(document),
        $body: $('body'),
        $utilityNav: this.$el.find('.wh-utility-navigation'),
        $utilityNavItem: this.$el.find('.wh-utility-navigation-item'),
        $utilityNavItemLink: this.$el.find('.wh-utility-navigation-item__link'),
        $utilityNavItemMobile: this.$el.find('.wh-header-navigation__utility-select'),
        $primaryNavItems: this.$el.find('.header__primary-nav-item'),
        $headerRegionLink: this.$el.find('.header__region-link'),
        $logo: this.$el.find('.wh-header-navigation__logo--screen'),
        $logoWrapper: this.$el.find('.wh-header-navigation__logo-wrapper')
      };

      this.classes = {
        searchOn: 'search-on',
        navOpen: 'nav-open',
        sticky: 'wh-header--is-sticky',
        stickyVisible: 'wh-header--is-sticky-visible',
        utilityOpen: 'utility-open'
      };
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.dom.$searchBtn.on('click', this.onToggleSearch.bind(this));
      this.dom.$document.on('click', this.onClickOutside.bind(this));
      this.dom.$burgerBtn.on('click', this.onToggleNav.bind(this));
      this.dom.$utilityNavItemLink.on('click', this.onToggleUtilityNavDropdown.bind(this));
      this.dom.$utilityNavItemMobile.on('change', this.onUtilityNavMobileChange.bind(this));
      this.dom.$utilityNavItemMobile.on('blur', this.onUtilityNavMobileClose.bind(this));
      this.dom.$headerRegionLink.on('click', this.handleHeaderRegionLink.bind(this));
      this.dom.$primaryNavItems.on('click', this.handlePrimaryNavLinkClick.bind(this));
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      new this.config.PredictiveSearch(this.$el, {
        endpoint: this.config.endpoint,
        itemsLimit: 5
      });
      if (this.$el.hasClass(this.classes.sticky) && !this.$el.hasClass(this.classes.stickyVisible)) {
        this.config.triggerElement.waypoint(function (direction) {
          if (direction === 'down') {
            _this2.dom.$headerNav.css('top', 0);
          } else {
            if (!$('body').hasClass('wh-search-box-focused')) {
              _this2.dom.$headerNav.css('top', -150);
              _this2.dom.$utilityNavItem.removeClass(_this2.classes.utilityOpen);
            }
          }
        });
      }
      this.setSelectric();
      return this;
    }
  }, {
    key: 'handleHeaderRegionLink',
    value: function handleHeaderRegionLink(e) {
      var selectedOption = e.currentTarget.childNodes[1].href;
      window.location.href = selectedOption;
    }
  }, {
    key: 'handlePrimaryNavLinkClick',
    value: function handlePrimaryNavLinkClick(e) {
      var $primaryNavItems = this.dom.$primaryNavItems;

      var parent = e.currentTarget.closest('.header__primary-nav-item');
      var dataset = parent.dataset;
      if (!dataset.itemOpen) {
        if (parent.childNodes.length > 3) {
          e.preventDefault();
          $primaryNavItems.filter(function (items) {
            return items !== parent;
          }).each(function (item) {
            return $primaryNavItems[item].removeAttribute('data-item-open');
          });
          parent.dataset.itemOpen = 'true';
        }
      } else {
        e.preventDefault();
        parent.removeAttribute('data-item-open');
      }
    }
  }, {
    key: 'setSelectric',
    value: function setSelectric() {
      var isMobile = navigator.platform.toLowerCase().match(/(iphone|ipod|ipad|android|arm)/) !== null ? true : false;
      this.dom.$utilityNavItemMobile.selectric({
        disableOnMobile: false,
        nativeOnMobile: isMobile
      });
      this.dom.$utilityNavItemMobile.selectricPlaceholder({});

      (0, _helpers.addLabelsToSelectric)();
    }
  }, {
    key: 'onToggleSearch',
    value: function onToggleSearch(e) {
      e.preventDefault();
      this.dom.$body.toggleClass(this.classes.navOpen);
      this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);

      if ($(window).width() > 1023) {
        this.$el.toggleClass(this.classes.searchOn);
      }

      if (this.dom.$body.hasClass(this.classes.navOpen)) {
        this.dom.$searchInput.focus();
      }
    }
  }, {
    key: 'onToggleNav',
    value: function onToggleNav(e) {
      e.preventDefault();
      this.dom.$body.toggleClass(this.classes.navOpen);
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      var _this3 = this;

      var $primaryNavItems = this.dom.$primaryNavItems;

      if (this.dom.$primaryNavItems.has(e.target).length === 0) {
        $primaryNavItems.each(function (item) {
          return $primaryNavItems[item].removeAttribute('data-item-open');
        });
      }

      if (this.dom.$body.hasClass(this.classes.navOpen) && this.dom.$headerNavBar.has(e.target).length === 0 && !this.dom.$searchBtn.is($(e.target).parents('.wh-header-navigation__search-icon'))) {
        this.dom.$body.removeClass(this.classes.navOpen);
      }

      if (!this.dom.$searchBox.is(e.target) && this.dom.$searchBox.has(e.target).length === 0 && !this.dom.$searchBtn.is($(e.target).parents('.wh-header-navigation__search-icon')) && !this.dom.$utilityNavItem.is(e.target) && this.dom.$utilityNavItem.has(e.target).length === 0) {
        _gsap.TweenLite.to(this.dom.$predictiveResults, 0.5, {
          height: 0,
          ease: _gsap.Expo.easeOut,
          onComplete: function onComplete() {
            _this3.dom.$predictiveResults.removeClass('expanded');
          }
        });
        this.$el.removeClass(this.classes.searchOn);
        this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);
      }
    }
  }, {
    key: 'onToggleUtilityNavDropdown',
    value: function onToggleUtilityNavDropdown(e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      var $parent = $($target.parents('.wh-utility-navigation-item')[0]);
      if ($parent.hasClass(this.classes.utilityOpen)) {
        $parent.removeClass(this.classes.utilityOpen);
        return;
      }

      this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);
      $parent.addClass(this.classes.utilityOpen);
    }
  }, {
    key: 'onUtilityNavMobileClose',
    value: function onUtilityNavMobileClose(e) {
      if (!this.$el.hasClass(this.classes.sticky)) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'onUtilityNavMobileChange',
    value: function onUtilityNavMobileChange(e) {
      var $target = $(e.currentTarget);
      var selectedOption = $target.val();
      window.location.href = selectedOption;
    }
  }]);

  return Header;
}(_component2.default);

exports.default = Header;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

var _debounce2 = __webpack_require__(206);

var _debounce3 = _interopRequireDefault(_debounce2);

var _template2 = __webpack_require__(91);

var _template3 = _interopRequireDefault(_template2);

var _remove2 = __webpack_require__(209);

var _remove3 = _interopRequireDefault(_remove2);

var _isEmpty2 = __webpack_require__(208);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _predictiveSearchItem = __webpack_require__(214);

var _predictiveSearchItem2 = _interopRequireDefault(_predictiveSearchItem);

var _constants = __webpack_require__(92);

var _gsap = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PredictiveSearch = function (_Component) {
  _inherits(PredictiveSearch, _Component);

  function PredictiveSearch(el, config) {
    _classCallCheck(this, PredictiveSearch);

    return _possibleConstructorReturn(this, (PredictiveSearch.__proto__ || Object.getPrototypeOf(PredictiveSearch)).call(this, el, config));
  }

  _createClass(PredictiveSearch, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $container: this.$el,
        $serchBox: this.$el.find('.wh-search-box'),
        $input: this.$el.find('.wh-search-box__field'),
        $searchBtn: this.$el.find('.wh-search-box__button'),
        $results: this.$el.find('.wh-predictive-search')
      };

      this.cssClasses = {
        searchGroup: 'wh-predictive-search-group'
      };

      this.endpoint = this.config.endpoint ? this.config.endpoint : _constants.ENDPOINT.getKeywordSearch;
      this.currentRequest = [];
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _this2 = this;

      this.dom.$input.on('keyup input', (0, _debounce3.default)(function (e) {
        _this2.onInputUp(e);
      }, 100));

      this.dom.$searchBtn.on('click touch', this.onSearch.bind(this));
      this.$el.on('click touch', '.wh-predictive-search-group__title', this.onHeadingClick.bind(this));
    }
  }, {
    key: 'getResults',
    value: function getResults(keyword, contenttype, requestIndex) {
      var _this3 = this;

      this.dom.$serchBox.addClass('loading');
      return $.ajax({
        url: this.endpoint,
        data: { keyword: keyword, contenttype: contenttype, take: this.config.itemsLimit ? this.config.itemsLimit : undefined },
        beforeSend: function beforeSend() {
          if (_this3.currentRequest[requestIndex] && _this3.currentRequest[requestIndex] !== null) {
            _this3.currentRequest[requestIndex].abort();
          }
        }
      });
    }
  }, {
    key: 'renderResults',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var data, items, noResults, noResultsString;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this.currentRequest[0] = this.getResults(value, _constants.SEARCH_GROUPS[0], 0), this.currentRequest[1] = this.getResults(value, _constants.SEARCH_GROUPS[1], 1), this.currentRequest[2] = this.getResults(value, _constants.SEARCH_GROUPS[2], 2), this.currentRequest[3] = this.getResults(value, _constants.SEARCH_GROUPS[3], 3), this.currentRequest[4] = this.getResults(value, _constants.SEARCH_GROUPS[4], 4), this.currentRequest[5] = this.getResults(value, _constants.SEARCH_GROUPS[5], 5), this.currentRequest[5] = this.getResults(value, _constants.SEARCH_GROUPS[6], 6), this.currentRequest[5] = this.getResults(value, _constants.SEARCH_GROUPS[7], 7), this.currentRequest[5] = this.getResults(value, _constants.SEARCH_GROUPS[8], 8), this.currentRequest[5] = this.getResults(value, _constants.SEARCH_GROUPS[9], 9)]);

              case 2:
                data = _context.sent;


                (0, _remove3.default)(data, function (n) {
                  return (0, _isEmpty3.default)(n);
                });

                this.dom.$serchBox.removeClass('loading');
                this.$el.trigger('search:keyword', data);

                items = '';


                if (data.length > 0) {
                  data.forEach(function (item) {
                    items += (0, _template3.default)(_predictiveSearchItem2.default)(item);
                  });

                  this.dom.$results.html(items);
                } else {
                  noResults = this.dom.$results.data('no-results-txt');
                  noResultsString = '<li class="wh-predictive-search__none">' + noResults + '</li>';


                  this.dom.$results.find('li').remove();
                  this.dom.$results.html(noResultsString);
                }

                this.dom.$results.removeClass('loading');

                if (!this.dom.$results.hasClass('expanded')) {
                  this.dom.$results.addClass('expanded');
                  _gsap.TweenLite.set(this.dom.$results, { height: 'auto', ease: _gsap.Expo.easeOut });
                  _gsap.TweenLite.from(this.dom.$results, 0.4, { height: 0, ease: _gsap.Expo.easeInOut });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function renderResults(_x) {
        return _ref.apply(this, arguments);
      }

      return renderResults;
    }()
  }, {
    key: 'destroyResults',
    value: function destroyResults() {
      var _this4 = this;

      _gsap.TweenLite.to(this.dom.$results, 0.5, { height: 0, ease: _gsap.Expo.easeOut, onComplete: function onComplete() {
          _this4.dom.$results.removeClass('expanded');
          _this4.dom.$results.find('li').remove();
        } });
    }
  }, {
    key: 'onInputUp',
    value: function onInputUp(e) {
      var value = this.dom.$input.val().trim();

      if (value.length < 1) {
        this.destroyResults();

        return;
      }

      if (value.length >= 1) {
        this.dom.$searchBtn.addClass('active');
      } else {
        this.dom.$searchBtn.removeClass('active');
      }

      if (e.which === 13) {
        this.destroyResults();
        window.open(this.dom.$serchBox.data('search-url') + '?keyword=' + encodeURIComponent(value), '_self');
        return;
      }

      this.renderResults(value).catch(function (err) {
        if (err.statusText !== 'abort') {
          console.error('There was an error getting your results', err);
        }
      });
    }
  }, {
    key: 'onHeadingClick',
    value: function onHeadingClick(e) {
      var $target = $(e.currentTarget);
      if ($target.hasClass('wh-predictive-search-group__title--false')) {
        return;
      }

      var $searchGroup = $target.parents('.' + this.cssClasses.searchGroup);
      var searchViewAllType = $searchGroup.data('predictive-view-all-type');
      var searchGroupLabel = $searchGroup.data('predictive-search-group');

      if (searchGroupLabel === 'Solutions' || searchGroupLabel === 'Locations' || searchGroupLabel === 'Careers') {
        searchGroupLabel = searchGroupLabel.substring(0, searchGroupLabel.length - 1);
      }

      var keyword = this.dom.$input.val().trim();
      window.open(this.dom.$serchBox.data('search-url') + '?area=' + (searchViewAllType ? encodeURIComponent(searchViewAllType) : encodeURIComponent(searchGroupLabel)) + '&keyword=' + encodeURIComponent(keyword), '_self');
    }
  }, {
    key: 'onSearch',
    value: function onSearch(e) {
      e.preventDefault();
      var keyword = this.dom.$input.val().trim();
      this.destroyResults();
      window.open(this.dom.$serchBox.data('search-url') + '?keyword=' + encodeURIComponent(keyword), '_self');
    }
  }]);

  return PredictiveSearch;
}(_component2.default);

exports.default = PredictiveSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSearchGAEvent = exports.numberWithCommas = exports.isOutOfViewport = exports.focusableElements = exports.isFocusable = exports.getScrollbarWidth = exports.isTabletLandscape = exports.isMobile = exports.iOS = exports.isMobileDevice = exports.goToPreviewPosition = exports.setScrollPosition = exports.getUrlParameter = exports.getQueryParams = exports.truncateString = exports.initSVG = exports.scrollTo = exports.getPreservedParamsString = exports.updateHistory = exports.getUrlParams = exports.close = exports.open = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.addLabelsToSelectric = addLabelsToSelectric;

var _gsap = __webpack_require__(90);

__webpack_require__(487);

/**
 * Opens an element
 *
 * @param el - DOM element
 * @param speed - Speed of animation
 * @param ease - Ease function
 * @param onComplete - On complete callback
 */
var open = exports.open = function open(el) {
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
  var ease = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'easeOut';
  var onComplete = arguments[3];

  _gsap.TweenMax.set(el, { height: 'auto' });
  _gsap.TweenMax.from(el, speed, { height: 0, ease: _gsap.Expo[ease], onComplete: onComplete });
};

/**
 * Closes an element
 *
 * @param el - DOM element
 * @param speed - Speed of animation
 * @param ease - Ease function
 * @param onComplete - On complete callback
 */
var close = exports.close = function close(el) {
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
  var ease = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'easeOut';
  var onComplete = arguments[3];

  _gsap.TweenMax.to(el, speed, { height: 0, ease: _gsap.Expo[ease], onComplete: onComplete });
};

/**
 * Returns query string parameters
 *
 * @param query - URL's query string
 */
var getUrlParams = exports.getUrlParams = function getUrlParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
};

// Capture initial query parameters on page load to preserve tracking params (e.g., UTM)
var _initialSearchParams = window.location.search;

// Param keys managed by listing/search components — these should NOT be
// carried over from the initial URL when a component clears them.
var _managedParamKeys = new Set(['keyword', 'currentpage', 'pagesize', 'dateRange', 'topic', 'topicname', 'topics', 'solution', 'solutionname', 'subtype', 'subtypename', 'type', 'boostscore', 'insight-type', 'insightsbytype', 'timerange', 'timerangefrom', 'timerangeto', 'format', 'area', 'series', 'seriesnames', 'person', 'personname', 'position', 'location', 'experience', 'letter', 'sort', 'upcoming', 'past', 'clecredit', 'firmevent', 'group', 'insightslanding', 'external-subtype', 'pagetype', 'pageid', 'people'].map(function (key) {
  return key.toLowerCase();
}));

/**
 * Pushes url to history state
 * Warning: will replace current querystring in URL
 * Preserves initial page load query params not managed by any component (e.g., UTM tracking params)
 * @param newQueryString - Query string to be used in browser and history
 */
var updateHistory = exports.updateHistory = function updateHistory(newQueryString) {
  var initialParams = getUrlParams(_initialSearchParams);
  var newParams = getUrlParams(newQueryString || '');

  // Start with only the non-managed initial params (e.g., UTM tracking params)
  var merged = {};
  Object.keys(initialParams).forEach(function (key) {
    if (!_managedParamKeys.has(key.toLowerCase()) && initialParams[key]) {
      merged[key] = initialParams[key];
    }
  });

  // Layer on the component's current params
  Object.keys(newParams).forEach(function (key) {
    if (newParams[key]) {
      merged[key] = newParams[key];
    }
  });

  var queryString = Object.keys(merged).filter(function (key) {
    return merged[key];
  }).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(merged[key]);
  }).join('&');

  var newURL = '' + location.origin + location.pathname + (queryString ? '?' + queryString : '');
  history.pushState({}, '', newURL);
};

/**
 * Gets the query string containing only the preserved (non-managed) params
 * Use this when a component needs to do a full page reload (e.g. window.location.search = getPreservedParamsString())
 * @returns {string} Query string starting with '?' or empty string
 */
var getPreservedParamsString = exports.getPreservedParamsString = function getPreservedParamsString() {
  var initialParams = getUrlParams(_initialSearchParams);

  var merged = {};
  Object.keys(initialParams).forEach(function (key) {
    if (!_managedParamKeys.has(key.toLowerCase()) && initialParams[key]) {
      merged[key] = initialParams[key];
    }
  });

  var queryString = Object.keys(merged).filter(function (key) {
    return merged[key];
  }).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(merged[key]);
  }).join('&');

  return queryString ? '?' + queryString : '';
};

/**
 * Scroll to point on a page
 *
 * @param y - Position to scroll to
 * @param speed - Speed of animation
 */
var scrollTo = exports.scrollTo = function scrollTo(y) {
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
  var onCompleteHandler = arguments[2];

  _gsap.TweenMax.to(window, speed, { scrollTo: { y: y }, ease: _gsap.Expo.easeOut, onComplete: onCompleteHandler });
};

/**
 * Initializes inline SVG's
 *
 * @param config - Configuration holding the DOM element and the target
 * Reference: https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
 */
var initSVG = exports.initSVG = function initSVG(config) {
  $(config.el).each(function (k, v) {
    var $img = $(v);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function (data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find(config.target);

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, else we gonna set it if we can.
      if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
      }

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });
};

var truncateString = exports.truncateString = function truncateString(str, n) {
  return str.substr(0, n - 1) + (str.length > n ? '&hellip;' : '');
};

/**
 * Parses a query string
 *
 * @param query - querystring to parse.
*/
var getQueryParams = exports.getQueryParams = function getQueryParams(query) {
  var params = {};

  query.replace(/([^?=&]+)(=([^&]*))?/g, function ($0, $1, $2, $3) {
    var key = $1.toLowerCase();

    params[key] = decodeURIComponent($3);
  });

  return params;
};

/**
 * Returns paramenter value
 *
 * @param sParam - URL param
 */
var getUrlParameter = exports.getUrlParameter = function getUrlParameter(sParam, url) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  var sParameterName = void 0,
      i = void 0;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

function addLabelsToSelectric() {
  setTimeout(function () {
    var selectricWrappers = $('.selectric-wrapper');

    if (selectricWrappers) {
      $.each(selectricWrappers, function (index, element) {
        var label = $(element).find('.selectric').find('.label');
        var id = 'input-id-' + Math.round(Math.random() * 10000);

        if (label) {
          var text = $(label).text();
          var hiddenInput = $(element).find('.selectric-input');

          if (hiddenInput.length) {
            $(hiddenInput).attr('id', id);
            $('<label class="visually-hidden" for="' + id + '">' + text + '</label>').insertBefore($(hiddenInput));
          }
        }
      });
    }
  }, 1000);
}

var setScrollPosition = exports.setScrollPosition = function setScrollPosition(name) {
  return sessionStorage.setItem('scrollToPrevPosition' + name, $(window).scrollTop());
};

var goToPreviewPosition = exports.goToPreviewPosition = function goToPreviewPosition(name) {
  var data = sessionStorage.getItem('scrollToPrevPosition' + name);

  if (data) {
    window.scrollTo({
      top: data
    });
    sessionStorage.removeItem('scrollToPrevPosition' + name);
  }
};

// /**
// * Checks browser is running on a native mobile device
// */
var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

// /**
// * Checks iOS user agent
// */
var iOS = exports.iOS = function iOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
};

// /**
// * Returns if media query matches mobile
// */
var isMobile = exports.isMobile = function isMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
};

// /**
// * Returns if media query matches tabletLandscape
// */
var isTabletLandscape = exports.isTabletLandscape = function isTabletLandscape() {
  return window.matchMedia('(max-width: 1023px)').matches;
};

// /**
// * Returns the browser's scrollbar width
// */
var getScrollbarWidth = exports.getScrollbarWidth = function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
};

// /**
// * Checks if an element is focusable
// *
// * @param {Object} el - HTML element you want to check if it's focusable
// */
var isFocusable = exports.isFocusable = function isFocusable(el) {
  if (el.tabIndex > 0 || el.tabIndex === 0 && el.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (el.disabled) {
    return false;
  }

  /* eslint-disable indent */
  switch (el.nodeName) {
    case 'A':
      return !!el.href && el.rel !== 'ignore';
    case 'INPUT':
      return el.type !== 'hidden' && el.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
  /* eslint-enable indent */
};

// /**
// * FOCUSABLE ELEMENTS
// */
var focusableElements = exports.focusableElements = ['[contenteditable]', '[tabindex]:not([tabindex^="-"])', 'a[href]', 'area[href]', 'button:not([disabled]):not([aria-hidden])', 'embed', 'iframe', 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', 'object', 'select:not([disabled]):not([aria-hidden])', 'textarea:not([disabled]):not([aria-hidden])'];

// * Check if an element is outside the viewport
// */
var isOutOfViewport = exports.isOutOfViewport = function isOutOfViewport(elem) {
  // Get element's bounding
  var bounding = elem.getBoundingClientRect();

  // Check if it's out of the viewport on each side
  var out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
};

var numberWithCommas = exports.numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var sendSearchGAEvent = exports.sendSearchGAEvent = function sendSearchGAEvent(event, search_term, num_search_results) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    search_term: search_term,
    num_search_results: num_search_results
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Accordion": [
		218,
		62
	],
	"./Accordion.js": [
		218,
		62
	],
	"./BioOverview": [
		219,
		61
	],
	"./BioOverview.js": [
		219,
		61
	],
	"./BlogListing": [
		220,
		0
	],
	"./BlogListing.js": [
		220,
		0
	],
	"./CaseStudySpotlight": [
		222,
		30
	],
	"./CaseStudySpotlight.js": [
		222,
		30
	],
	"./ColumnCareersRow": [
		223,
		29
	],
	"./ColumnCareersRow.js": [
		223,
		29
	],
	"./Component": [
		33
	],
	"./Component.js": [
		33
	],
	"./ContactsListing": [
		224,
		60
	],
	"./ContactsListing.js": [
		224,
		60
	],
	"./EmailDisclaimerModal": [
		132
	],
	"./EmailDisclaimerModal.js": [
		132
	],
	"./ExperienceListing": [
		225,
		59
	],
	"./ExperienceListing.js": [
		225,
		59
	],
	"./FeaturedSolutionSlider": [
		226,
		28
	],
	"./FeaturedSolutionSlider.js": [
		226,
		28
	],
	"./HomepageFeaturedContent": [
		227,
		58
	],
	"./HomepageFeaturedContent.js": [
		227,
		58
	],
	"./HomepageHero": [
		228,
		57
	],
	"./HomepageHero.js": [
		228,
		57
	],
	"./HomepageMasthead": [
		229,
		27
	],
	"./HomepageMasthead.js": [
		229,
		27
	],
	"./InsightsListing": [
		230,
		56
	],
	"./InsightsListing.js": [
		230,
		56
	],
	"./InsightsSlider": [
		231,
		26
	],
	"./InsightsSlider.js": [
		231,
		26
	],
	"./NewsArticle": [
		232,
		55
	],
	"./NewsArticle.js": [
		232,
		55
	],
	"./NoteworthyContent": [
		233,
		54
	],
	"./NoteworthyContent.js": [
		233,
		54
	],
	"./Pagination": [
		207,
		53
	],
	"./Pagination.js": [
		207,
		53
	],
	"./ReadMore": [
		234,
		52
	],
	"./ReadMore.js": [
		234,
		52
	],
	"./RecognitionListing": [
		235,
		51
	],
	"./RecognitionListing.js": [
		235,
		51
	],
	"./ShowcaseCarousel": [
		236,
		24
	],
	"./ShowcaseCarousel.js": [
		236,
		24
	],
	"./Statistics": [
		237,
		5
	],
	"./Statistics.js": [
		237,
		5
	],
	"./TeamSpotlightGrid": [
		238,
		23
	],
	"./TeamSpotlightGrid.js": [
		238,
		23
	],
	"./TestimonialCarousel": [
		239,
		22
	],
	"./TestimonialCarousel.js": [
		239,
		22
	],
	"./TrendingTopicsCarousel": [
		240,
		4
	],
	"./TrendingTopicsCarousel.js": [
		240,
		4
	],
	"./TrendingTopicsCarouselSlider": [
		215,
		21
	],
	"./TrendingTopicsCarouselSlider.js": [
		215,
		21
	],
	"./VideoModal": [
		134
	],
	"./VideoModal.js": [
		134
	],
	"./about/AboutOverviewNav": [
		241,
		50
	],
	"./about/AboutOverviewNav.js": [
		241,
		50
	],
	"./about/VideoGrid": [
		242,
		49
	],
	"./about/VideoGrid.js": [
		242,
		49
	],
	"./article/ArticleBrief": [
		243,
		48
	],
	"./article/ArticleBrief.js": [
		243,
		48
	],
	"./article/ArticleFootnotes": [
		244,
		47
	],
	"./article/ArticleFootnotes.js": [
		244,
		47
	],
	"./article/ArticleSeeMore": [
		245,
		46
	],
	"./article/ArticleSeeMore.js": [
		245,
		46
	],
	"./book/Author": [
		246,
		20
	],
	"./book/Author.js": [
		246,
		20
	],
	"./book/ExcerptsModal": [
		135
	],
	"./book/ExcerptsModal.js": [
		135
	],
	"./book/ReviewsTestimonials": [
		247,
		19
	],
	"./book/ReviewsTestimonials.js": [
		247,
		19
	],
	"./careers/FeaturedContentCarousel": [
		248,
		1
	],
	"./careers/FeaturedContentCarousel.js": [
		248,
		1
	],
	"./careers/JobListing": [
		249,
		45
	],
	"./careers/JobListing.js": [
		249,
		45
	],
	"./event-listing/PredictiveSearch": [
		251,
		44
	],
	"./event-listing/PredictiveSearch.js": [
		251,
		44
	],
	"./event-listing/Search": [
		252,
		11
	],
	"./event-listing/Search.js": [
		252,
		11
	],
	"./event-listing/SubscribeCallout": [
		253,
		43
	],
	"./event-listing/SubscribeCallout.js": [
		253,
		43
	],
	"./event/EventVideoPlayer": [
		250,
		2
	],
	"./event/EventVideoPlayer.js": [
		250,
		2
	],
	"./global": [
		64
	],
	"./global/": [
		64
	],
	"./global/BackToTop": [
		254,
		42
	],
	"./global/BackToTop.js": [
		254,
		42
	],
	"./global/CookieUseDisclaimer": [
		136
	],
	"./global/CookieUseDisclaimer.js": [
		136
	],
	"./global/Header": [
		137
	],
	"./global/Header.js": [
		137
	],
	"./global/PredictiveSearch": [
		138
	],
	"./global/PredictiveSearch.js": [
		138
	],
	"./global/SectionNav": [
		255,
		18
	],
	"./global/SectionNav.js": [
		255,
		18
	],
	"./global/ShareComponent": [
		256,
		41
	],
	"./global/ShareComponent.js": [
		256,
		41
	],
	"./global/ShareThis": [
		257,
		40
	],
	"./global/ShareThis.js": [
		257,
		40
	],
	"./global/StickyHeader": [
		258,
		39
	],
	"./global/StickyHeader.js": [
		258,
		39
	],
	"./global/TwoColumns": [
		259,
		38
	],
	"./global/TwoColumns.js": [
		259,
		38
	],
	"./global/index": [
		64
	],
	"./global/index.js": [
		64
	],
	"./insights-events/PredictiveSearch": [
		262,
		17
	],
	"./insights-events/PredictiveSearch.js": [
		262,
		17
	],
	"./insights-listing/NewPredictiveSearch": [
		263,
		16
	],
	"./insights-listing/NewPredictiveSearch.js": [
		263,
		16
	],
	"./insights-listing/Search": [
		264,
		10
	],
	"./insights-listing/Search.js": [
		264,
		10
	],
	"./insights/PredictiveSearch": [
		260,
		15
	],
	"./insights/PredictiveSearch.js": [
		260,
		15
	],
	"./insights/Search": [
		261,
		9
	],
	"./insights/Search.js": [
		261,
		9
	],
	"./newslisting/PredictiveSearch": [
		265,
		37
	],
	"./newslisting/PredictiveSearch.js": [
		265,
		37
	],
	"./newslisting/Search": [
		266,
		8
	],
	"./newslisting/Search.js": [
		266,
		8
	],
	"./newsroom/PredictiveSearch": [
		267,
		14
	],
	"./newsroom/PredictiveSearch.js": [
		267,
		14
	],
	"./people/BioMessage": [
		216,
		36
	],
	"./people/BioMessage.js": [
		216,
		36
	],
	"./people/PeopleHeader": [
		268,
		35
	],
	"./people/PeopleHeader.js": [
		268,
		35
	],
	"./people/PredictiveSearch": [
		269,
		3
	],
	"./people/PredictiveSearch.js": [
		269,
		3
	],
	"./people/Search": [
		270,
		7
	],
	"./people/Search.js": [
		270,
		7
	],
	"./report/ReportStickyNavigation": [
		271,
		34
	],
	"./report/ReportStickyNavigation.js": [
		271,
		34
	],
	"./search-listing/PredictiveSearch": [
		274,
		33
	],
	"./search-listing/PredictiveSearch.js": [
		274,
		33
	],
	"./search-listing/Search": [
		275,
		6
	],
	"./search-listing/Search.js": [
		275,
		6
	],
	"./search/PredictiveSearch": [
		272,
		32
	],
	"./search/PredictiveSearch.js": [
		272,
		32
	],
	"./search/Search": [
		273,
		25
	],
	"./search/Search.js": [
		273,
		25
	],
	"./solution/FeaturedLinksRow": [
		276,
		13
	],
	"./solution/FeaturedLinksRow.js": [
		276,
		13
	],
	"./solution/GeographicReach": [
		277,
		31
	],
	"./solution/GeographicReach.js": [
		277,
		31
	],
	"./solution/InsightsRow": [
		278,
		12
	],
	"./solution/InsightsRow.js": [
		278,
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 176;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports = " <% if(WorkPosition !== null && WorkPosition !== \"\") { %> <div class=\"wh-global-search-results-item wh-global-search-results-item--people\"> <% } else { %> <div class=wh-global-search-results-item> <% }; %> <div class=wh-global-search-results-item__link> <% if(Image.Src) { %> <% if(WorkPosition !== null && WorkPosition !== \"\") { %> <div class=\"wh-global-search-results-item__image wh-global-search-results-item__image--people\"> <img src=\"<%= Image.Src %>\" alt=\"<%= Image.Alt %>\"> </div> <% } else { %> <div class=wh-global-search-results-item__image> <img src=\"<%= Image.Src %>\" alt=\"<%= Image.Alt %>\"> </div> <% }; %> <% }; %> <div class=wh-global-search-results-item__content> <div class=wh-global-search-results-item__type-wrapper> <span class=wh-global-search-results-item__type><%= Category.Title %></span> <% if(Type !== null && Type.Title !== \"\") { %><span class=wh-global-search-results-item__subtype><%= Type.Title %></span><% }; %> </div> <% if(typeof PublishDate !== \"undefined\" && PublishDate !== \"\") { %><span class=wh-global-search-results-item__date><%= PublishDate %></span><% }; %> <div class=wh-global-search-results-item__content-main> <% if(Title !== \"\") { %> <h3 class=wh-global-search-results-item__title> <a href=\"<%= Link %>\"><%= Title %></a> </h3> <% }; %> <% if(WorkPosition !== null && WorkPosition !== \"\") { %> <h4 class=wh-global-search-results-item__position><%= WorkPosition %></h4> <% }; %> <% if(typeof DescriptionMobile !== \"undefined\" && DescriptionMobile !== \"\") { %><div class=\"wh-global-search-results-item__description wh-global-search-results-item__description--mobile\"><%= DescriptionMobile %></div><% }; %> <% if(typeof DescriptionTablet !== \"undefined\" && DescriptionTablet  !== \"\") { %><div class=\"wh-global-search-results-item__description wh-global-search-results-item__description--tablet\"><%= DescriptionTablet %></div><% }; %> <% if(typeof DescriptionDesktop !== \"undefined\" &&  DescriptionDesktop  !== \"\") { %><div class=\"wh-global-search-results-item__description wh-global-search-results-item__description--desktop\"><%= DescriptionDesktop %></div><% }; %> <% if(typeof Email !== \"undefined\" && Email) { %> <a href=\"mailto:<%= Email %>\" class=wh-global-search-results-item__email><%= Email %></a><% }; %> </div> <% if((typeof Locations !== \"undefined\" && Locations.length > 0) || (typeof PDF !== \"undefined\" && PDF.Link)) { %> <div class=wh-global-search-results-item__content-right> <% if(typeof Locations !== \"undefined\" && Locations.length > 0) { %> <% for (let i = 0; i < Locations.length; i++) { %> <a href=\"<%= Locations[i].Url %>\" class=wh-global-search-results-item__location><%= Locations[i].Location %></a> <% if(Locations[i].Telephone) { %> <a href=\"tel:<%= Locations[i].Telephone %>\" class=wh-global-search-results-item__telephone><%= Locations[i].Telephone %></a> <% }; %> <% }; %> <% }; %> <% if(typeof Pdf !== \"undefined\" && Pdf.Link) { %> <a href=\"<%= Pdf.Link %>\" class=wh-global-search-results-item__pdf><%= Pdf.Title %>  <% }; %> </a></div> <% }; %> </div> </div> </div> </div>";

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

module.exports = "<li class=wh-predictive-search-group data-predictive-search-group=\"<%= GroupName %>\" data-predictive-search-subtype=\"<%= Subtype %>\" <% if(ViewAllType) { %> data-predictive-view-all-type=\"<%= ViewAllType %>\" <% } %> > <h3 class=\"wh-predictive-search-group__title wh-predictive-search-group__title--view-all-<%= ViewAll %>\"> <%= GroupName %> <% if(ViewAll) { %> <span class=wh-predictive-search-group__hover>View All</span> <% } %> </h3> <ul class=wh-predictive-search-group__items> <% for (let i = 0; i < Listing.length; i++) { %> <li> <% if(Listing[i].Link) { %> <a href=\"<%= Listing[i].Link %>\"><%= Listing[i].Title %></a> <% } else { %> <a class=keyword href=# data-value=\"<%= Listing[i].Value %>\"><%= Listing[i].Title %></a> <% } %> </li> <% }; %> </ul> </li> ";

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(280);
module.exports = __webpack_require__(482);


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var domTree = new WeakMap();
var configuration = new WeakMap();

/**
 * Component is a class that should be extended for every component that's being made. It
 * is a helper class to keep the code uniform.
 *
 * __PLEASE NOTE__: This is only to be extended, not instantiated.
 *
 * @example
 * import Component from 'component';
 *
 * class Foo extends Component {
 *   construction(el, config){
 *     super(el, config);
 *   }
 *
 *   setupDefaults(){
 *     this.dom = {
 *       // ...jquery elements go here
 *     }
 *   }
 *
 *   addListeners(){
 *     // ...listeners go here
 *   }
 * }
 *
 *
 * // Create a new Foo component with some configuration
 * new Foo('.foo', {
 *   name: 'Foo'
 * })
 */

var Component = function () {
  /**
   * Component constructor
   *
   * @param {string|Object} el - Main DOM element, you can pass a string such as `'.foo'` __or__ a jQuery object such as `$('.foo')`
   * @param {Object} [config={ }] - Additional component configuration
   */
  function Component(el) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Component);

    if (typeof el === 'undefined') {
      throw new Error('You must provide an element as a String type or a jQuery object type');
    }

    /**
     * Main class element, this will be a jQuery instance
     *
     * @type {Object}
     */
    this.$el = el instanceof jQuery ? el : $(el);

    if (this.$el.length === 0) return;

    domTree.set(this, {});
    configuration.set(this, config);

    if (this.config.hasOwnProperty('dom')) {
      this.dom = this.config.dom;
    }

    this.setupDefaults();
    this.addListeners();
  }

  /**
   * This method is used for override;
   * It's called directly after the element and configuration have been set up
   */


  _createClass(Component, [{
    key: 'setupDefaults',
    value: function setupDefaults() {}

    /**
     * This method is used for override;
     * It's called directly after `setupDefaults()`, so everything is ready and set up at this point.
     */

  }, {
    key: 'addListeners',
    value: function addListeners() {}

    /**
     * Get component configuration
     *
     * @example
     * this.config
     *
     * @type {Object}
     */

  }, {
    key: 'config',
    get: function get() {
      return configuration.get(this);
    }

    /**
     * Get DOM object
     *
     * @example
     * this.dom
     *
     * @type {Object}
     */

  }, {
    key: 'dom',
    get: function get() {
      return domTree.get(this);
    }

    /**
     * Set DOM object
     *
     * @example
     * this.dom = {
     *   $foo: this.$el.find('.foo')
     * };
     *
     * @type {Object}
     */
    ,
    set: function set(elements) {
      elements = _extends({}, this.dom, elements);

      domTree.set(this, elements);
    }
  }]);

  return Component;
}();

exports.default = Component;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(10)))

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _bootstrap = __webpack_require__(483);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _constants = __webpack_require__(92);

var _global = __webpack_require__(64);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  // Globals
  ////////////////
  (0, _global2.default)();
  $('.wh-insights-slider-item__title').dotdotdot({
    watch: 'window'
  });

  $('.wh-recent-news-item__title').dotdotdot({
    watch: 'window',
    height: 100
  });

  // On demand
  ////////////////
  (0, _bootstrap2.default)('global/SectionNav', '.wh-section-nav').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('people/PeopleHeader', '.wh-people-header').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component(el);
  });

  (0, _bootstrap2.default)('RecognitionListing', '.wh-recognition-details').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('solution/InsightsRow', '.wh-insights-row').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      if (window.matchMedia('(min-width: 1100px)').matches) return;
      new component($target);
    });
  });

  (0, _bootstrap2.default)('solution/FeaturedLinksRow', '.wh-featured-links-row').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      if (window.matchMedia('(min-width: 1100px)').matches) return;
      new component($target);
    });
  });

  (0, _bootstrap2.default)('ExperienceListing', '.wh-experience-listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('InsightsListing', '.wh-insights-listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target, {
        template: {
          item: __webpack_require__(604),
          tab: __webpack_require__(605)
        },
        endpoint: {
          getInsightsListing: _constants.ENDPOINT.getInsightsListing,
          getInsightsListingVisibility: _constants.ENDPOINT.getInsightsListingVisibility
        },
        pagesize: 3
      });
    });
  });

  (0, _bootstrap2.default)('Accordion', '.wh-accordion').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('event-listing/SubscribeCallout', '.wh-subscribe-callout').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('InsightsSlider', '.wh-insights-slider').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('global/StickyHeader', '.wh-sticky-header').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target, {
        progressBarContent: '.wh-scroll-progress__content',
        endpoint: _constants.ENDPOINT.getPdfPage
      });
    });
  });

  (0, _bootstrap2.default)('ReadMore', '.wh-content-readmore').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('solution/GeographicReach', '.wh-geographic-reach').then(function (data) {
    if (!data) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('article/ArticleBrief', '.wh-article-brief').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('article/ArticleSeeMore', '.wh-article-body--seemore').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('global/TwoColumns', '.row--cols2').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('Statistics', '.wh-statistics').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)(['people/Search', 'people/PredictiveSearch'], '.wh-people-search').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: __webpack_require__(606),
      predictiveEndpoint: _constants.ENDPOINT.getBioKeywordSearch,
      endpoint: _constants.ENDPOINT.getPeopleSearchResults,
      pagesize: {
        list: 30
      },
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['insights/Search', 'insights/PredictiveSearch'], '.wh-insights-search').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: {
        all: __webpack_require__(89),
        blog: __webpack_require__(607)
      },
      endpoint: _constants.ENDPOINT.getInsightsSearchResults,
      predictiveEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: {
        list: 30
      },
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['insights/Search', 'newsroom/PredictiveSearch'], '.wh-new-search--newsroom').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: __webpack_require__(205),
      endpoint: _constants.ENDPOINT.getInsightsSearchResults,
      predictiveEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: 30,
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['newslisting/Search', 'newslisting/PredictiveSearch'], '.wh-new-search--listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: {
        all: __webpack_require__(89)

      },
      endpoint: _constants.ENDPOINT.getInsightsSearchResults,
      predictiveEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: {
        list: 30
      },
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['search-listing/Search', 'search-listing/PredictiveSearch'], '.wh-new-search-listing--listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: {
        all: __webpack_require__(608)

      },
      endpoint: _constants.ENDPOINT.getSearchResults,
      predictiveEndpoint: _constants.ENDPOINT.getKeywordSearch,
      pagesize: {
        list: 30
      },
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)('event/EventVideoPlayer', '.event-video-player').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;

    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)(['insights-listing/Search', 'insights-listing/NewPredictiveSearch'], '.wh-new-insights-search--listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: {
        all: __webpack_require__(89)
      },
      endpoint: _constants.ENDPOINT.getInsightsSearchResults,
      predictiveEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: 30,
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['insights-events/PredictiveSearch'], '.wh-insight-events-search').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: __webpack_require__(89),
      predictiveEventsEndpoint: _constants.ENDPOINT.getEventsPredictive,
      predictiveInsightsEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: 30,
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['event-listing/Search', 'event-listing/PredictiveSearch'], '.wh-new-events-search--listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: {
        all: __webpack_require__(609)
      },
      endpoint: _constants.ENDPOINT.getEventsListing,
      predictiveEndpoint: _constants.ENDPOINT.getInsightsPredictive,
      pagesize: 30,
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)(['search/Search', 'search/PredictiveSearch'], '.wh-global-search').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      template: __webpack_require__(205),
      endpoint: _constants.ENDPOINT.getSearchResults,
      tabsEndpoint: _constants.ENDPOINT.getSearchResultsTabs,
      pagesize: 30,
      PredictiveSearch: component[1]
    });
  });

  (0, _bootstrap2.default)('about/AboutOverviewNav', '.wh-about-overview-nav__select').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('ShowcaseCarousel', '.wh-showcase-carousel').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)(['HomepageHero', 'global/PredictiveSearch'], '.wh-home-page-hero').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    new component[0](el, {
      PredictiveSearch: component[1],
      interval: 7000
    });
  });

  (0, _bootstrap2.default)('HomepageFeaturedContent', '.homepage-featured-content').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('article/ArticleFootnotes', '.wh-article-body').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('careers/FeaturedContentCarousel', '.featured-content-carousel').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('book/ReviewsTestimonials', '.wh-reviews-testimonials').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('book/Author', '.wh-author__content').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('global/ShareThis', '.wh-sticky-header-sharethis').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('global/ShareComponent', '.share-component').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('global/BackToTop', '.wh-back-to-top').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('about/VideoGrid', '.wh-video-grid').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('BlogListing', '.wh-blog-listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target, {
        template: __webpack_require__(610),
        endpoint: _constants.ENDPOINT.getBlogListing,
        pagesize: 18
      });
    });
  });

  (0, _bootstrap2.default)('careers/JobListing', '.wh-job-listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target, {
        template: __webpack_require__(611),
        endpoint: _constants.ENDPOINT.getJobListing,
        pagesize: 18
      });
    });
  });

  (0, _bootstrap2.default)('ContactsListing', '.wh-contact-us-listing').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target.closest('[role="main"]'), {
        template: __webpack_require__(612),
        endpoint: _constants.ENDPOINT.getContactListing
      });
    });
  });

  (0, _bootstrap2.default)('NoteworthyContent', '.wh-noteworthy-content').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('NewsArticle', '.wh-article-hero').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('BioOverview', '.wh-bio-overview').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('TeamSpotlightGrid', '.team-spotlight-grid').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('FeaturedSolutionSlider', '.featured-solution').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('TestimonialCarousel', '.testimonial-carousel').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('CaseStudySpotlight', '.case-study').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('ColumnCareersRow', '.column-careers-row').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('HomepageMasthead', '.homepage-masthead').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('TrendingTopicsCarousel', '.trending-topics-carousel').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });

  (0, _bootstrap2.default)('report/ReportStickyNavigation', '.report-sticky-navigation').then(function (data) {
    if (!data) return;
    var component = data.component,
        el = data.el;


    (0, _bootstrap.render)(el, function ($target) {
      new component($target);
    });
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Imports a chunked component async
 *
 * @param name - Name of the Javascript file
 * @param el - Name of the element
 * @returns {Promise.<*>}
 */
exports.default = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var imports;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!el) {
              _context.next = 5;
              break;
            }

            if (exists(el)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:
            _context.next = 6;
            break;

          case 5:
            throw new Error('You must pass an element in.');

          case 6:
            if (!Array.isArray(name)) {
              _context.next = 12;
              break;
            }

            imports = [];


            name.forEach(function (v) {
              imports.push(__webpack_require__(176)("./" + v));
            });

            _context.next = 11;
            return Promise.all(imports).then(function (resp) {
              var component = [];

              resp.forEach(function (v) {
                component.push(v.default);
              });

              return {
                component: component,
                el: el
              };
            }).catch(function (err) {
              Promise.reject(new Error('There was an error loading your component - ' + err));
            });

          case 11:
            return _context.abrupt('return', _context.sent);

          case 12:
            _context.next = 14;
            return __webpack_require__(176)("./" + name).then(function (component) {
              return {
                component: component.default,
                el: el
              };
            }).catch(function (err) {
              Promise.reject(new Error('There was an error loading your component - ' + err));
            });

          case 14:
            return _context.abrupt('return', _context.sent);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function importComponent(_x2) {
    return _ref.apply(this, arguments);
  }

  return importComponent;
}();

/**
 * Check if an element exists in the DOM tree
 *
 * @param el - DOM element
 * @returns {boolean}
 */


var exists = exports.exists = function exists(el) {
  return document.querySelector(el) !== null;
};

/**
 * Renders component with callback
 *
 * @param el - Name of the element
 * @param cb - Callback
 */
function render(el, cb) {
  var elements = document.querySelectorAll(el);
  var length = elements.length;

  for (var i = 0; i < length; ++i) {
    cb($(elements[i]));
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTooltips = undefined;

__webpack_require__(601);

var initTooltips = exports.initTooltips = function initTooltips() {
  $('.wh-related-solutions-links__link a').tooltipster({
    theme: 'tooltipster-solutions',
    arrow: false
  });

  $('.wh-solution-listing-item a').tooltipster({
    theme: 'tooltipster-solutions-list',
    arrow: false
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

module.exports = "<div class=wh-video-modal id=wh-video-modal> <div class=\"wh-video-modal__content row\"> <div class=wh-video-modal__container> <% if (data.hasVimeoVideo) { %> <iframe class=\"wh-video-modal__video video-js\" src=\"<%= data.vimeoVideoUrl%>\" frameborder=0 allow=\"autoplay; fullscreen; picture-in-picture\"></iframe> <% } else { %> <video data-account=\"<%= data.accountId %>\" data-video-id=\"<%= data.videoId %>\" data-player=\"<%= data.playerId %>\" data-account=\"<%= data.has %>\" data-embed=default data-application-id autoplay class=\"wh-video-modal__video video-js\" controls></video> <script src=\"//players.brightcove.net/<%= data.accountId %>/<%= data.playerId %>_default/index.min.js\"></script> <% } %> </div> </div> </div>";

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports = "<div class=wh-excerpts-modal id=wh-excerpts-modal> <div class=wh-excerpts-modal__content> <div class=wh-excerpts-modal__content-wrapper> <aside class=wh-excerpts-modal-menu> <ul class=wh-excerpts-modal-menu__list> <% for (let i = 0; i < data.length; i++) { %> <% if(i===0) { %> <li class=\"wh-excerpts-modal-menu__item active\"> <% } else { %> </li><li class=wh-excerpts-modal-menu__item> <% } %> <a href=# data-excerpt-key=\"<%= i %>\"><%= data[i].Title %></a> </li> <% }; %> </ul> </aside> <article class=wh-excerpts-modal__main> <h2 class=wh-excerpts-modal__title><%= data[0].Title %></h2> <%= data[0].Content %> </article> </div> <a href=# class=wh-excerpts-modal__btn-back>View Excerpts</a> </div> </div> ";

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports = "<div class=wh-insights-listing-result> <div class=wh-insights-listing-result__top> <ul class=wh-insights-listing-result__types> <% if(SubTypes) { %> <% for (let i = 0; i < SubTypes.length; i++) { %> <li class=\"wh-insights-listing-result__types-item wh-insights-listing-result__types-item--type\"> <span><%- SubTypes[i].Title %></span> </li> <% }; %> <% }; %> <% if(typeof ParentListingName !== \"undefined\" && ParentListingName) { %> <li class=wh-insights-listing-result__types-item> <span><%- ParentListingName %></span> </li> <% }; %> </ul> <span class=wh-insights-listing-result__date><%= Date %></span> </div> <h3 class=wh-insights-listing-result__title> <% if (Link && Link.Src != \"\") { %> <a href=\"<%= Link.Src %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <% if (Description) { %> <div class=wh-insights-listing-result__description> <%= Description %> </div> <% } %> </div> ";

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports = "<li class=wh-insights-listing-filters__item> <a href=\"\" data-filter=\"<%=Type%>\" class=wh-insights-listing-filters__item-link data-search-type=\"<%=Type%>\" data-search-type-uuid=\"<%=ContentTypeId%>\" data-search-subtype-uuid=\"<%=ContentSubTypeIds%>\"> <%=TabDisplayName%> </a> </li> ";

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports = "<% const personClass = Link && ProfileImage ? '' : 'no-image' %> <li class=\"wh-person <%= personClass %>\"> <div class=wh-person__left> <% if(Link && ProfileImage) { %> <a class=wh-person__img href=\"<%= Link %>\"><img src=\"<%= ProfileImage %>\" alt=\"<%= FullName %>\"/></a> <% }; %> <div class=wh-person__wrapper> <h4 class=wh-person__name><a href=\"<%= Link %>\"><%= FullName %></a></h4> <% if(Level) { %><h5 class=wh-person__title><%= Level %></h5><% }; %> <% if(Email) { %> <a href=\"mailto:<%= Email %>\" class=wh-person__email><%= Email %></a><% }; %> </div> </div> <% if(Locations !== null && Locations.length > 0) { %> <div class=wh-person__right> <% for (let i = 0; i < Locations.length; i++) { %> <% if(Locations[i].Location) { %> <a href=\"<%= Locations[i].Url %>\" class=wh-person__location><%= Locations[i].Location %></a> <% }; %> <% if(Locations[i].Telephone) { %> <a href=\"tel:<%= Locations[i].Telephone %>\" class=wh-person__telephone><%= Locations[i].Telephone %></a> <% }; %> <% }; %> </div> <% }; %> </li> ";

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports = "<div class=\"wh-insights-search-results-item wh-insights-search-results-item--blog wh-insights-search-results-item--<%= Theme %>\"> <div class=wh-insights-search-results-item__image style=\"background-image:url(<%= Image.Src %>)\"></div> <a href=\"<%= Link.Url %>\" class=wh-insights-search-results-item__content> <h3 class=wh-insights-search-results-item__title> <%= Title %> </h3> <span class=\"wh-insights-search-results-item__cta btn--new-page\"><%= Link.Label %></span> </a> </div> ";

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

module.exports = "<div class=wh-insights-search-results-item> <div class=wh-insights-search-results-item__wrapper data-link=\"<%= Link.Src %>\"> <% if(Image) { %> <div class=wh-insights-search-results-item__image style=\"background-image:url(<%= Image.Src %>)\"></div> <% } %> <div class=wh-insights-search-results-item__content> <div class=wh-insights-search-results-item__top> <ul class=wh-insights-search-results-item__types> <% if(Type !== null && Type.Title !== \"\") { %> <li class=\"wh-insights-listing-result__types-item wh-insights-listing-result__types-item--type\"> <span><%= Type.Title %></span> </li> <% }; %> <% if(SubType && SubType.Title) { %> <li class=wh-insights-listing-result__types-item> <span><%= SubType.Title %></span> </li> <% }; %> </ul> <span class=wh-insights-search-results-item__date><%= PublishDate %></span> </div> <h3 class=wh-insights-search-results-item__title> <% if(Link) { %> <a href=\"<%= Link %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <div class=wh-insights-search-results-item__description> <div><%= Description %></div> </div> </div> </div> </div> ";

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports = "<div class=\"wh-insights-search-results-item wh-events-search-results-item\"> <div class=wh-insights-search-results-item__wrapper data-link=\"<%= Link.Src %>\"> <% if(Image) { %> <div class=wh-insights-search-results-item__image style=\"background-image:url(<%= Image.Src %>)\"></div> <% } %> <div class=wh-insights-search-results-item__content> <div class=wh-insights-search-results-item__top> <ul class=wh-insights-search-results-item__types> <% if(SubTypes !== null && SubTypes.length > 0) { %> <% for (let i = 0; i < SubTypes.length; i++) { %> <li class=\"wh-insights-listing-result__types-item wh-insights-listing-result__types-item--type\"> <span><%= SubTypes[i].Title %></span> </li> <% }; %> <% }; %> </ul> <span class=wh-insights-search-results-item__date><%= Date %></span> </div> <h3 class=\"wh-insights-search-results-item__title wh-events-search-results-item__title\"> <% if(Link.Src) { %> <a href=\"<%= Link.Src %>\" title=\"<%= Link.Alt %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <div class=wh-insights-search-results-item__description> <div><%= Description %></div> </div> <% if(PDF.Link && PDF.Title) { %> <a href=\"<%= PDF.Link %>\" class=wh-insights-search-results-item__pdf><%= PDF.Title %></a> <% } %> </div> </div> </div> ";

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports = "<li class=wh-blog-listing-results-item> <a href=\"<%= data.Link %>\"> <h3 class=wh-blog-listing-results-item__title> <%= data.Title %> </h3> <span class=wh-blog-listing-results-item__date><%= data.Date %></span> </a> <div class=wh-blog-listing-results-item__description> <%= data.Description %> </div> </li> ";

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

module.exports = "<div class=wh-job-listing-result> <h3 class=wh-job-listing-result__title> <% if(Url) { %> <a href=\"<%= Url %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <div class=wh-job-listing-result__teaser><%= Teaser %></div> <span class=wh-job-listing-result__municipality><%= Municipality %></span> </div> ";

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

module.exports = " <div class=wh-contact-groups-grid-group> <% if(data.Title) { %> <h4 class=wh-contact-groups-grid-group__title><%= data.Title %></h4> <% }; %> <ul class=wh-contacts-listing__list> <% _forEach(data.Contacts, (contact) => { %> <li class=wh-contact-item> <h2 class=wh-contact-item__name><%= contact.Name %></h2> <h3 class=wh-contact-item__title><%= contact.Position %></h3> <a href=\"<%= contact.Email %>\" class=wh-contact-item__email><%= contact.Email %></a> <a href=\"tel:<%= contact.Phone %>\" class=wh-contact-item__telephone><%= contact.Phone %></a> </li> <% }); %> </ul> </div> ";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(139);

var _tooltips = __webpack_require__(600);

var _constants = __webpack_require__(92);

__webpack_require__(212);

var _VideoModal = __webpack_require__(134);

var _VideoModal2 = _interopRequireDefault(_VideoModal);

var _ExcerptsModal = __webpack_require__(135);

var _ExcerptsModal2 = _interopRequireDefault(_ExcerptsModal);

var _EmailDisclaimerModal = __webpack_require__(132);

var _EmailDisclaimerModal2 = _interopRequireDefault(_EmailDisclaimerModal);

var _CookieUseDisclaimer = __webpack_require__(136);

var _CookieUseDisclaimer2 = _interopRequireDefault(_CookieUseDisclaimer);

var _Header = __webpack_require__(137);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function global() {
  // Inline SVGs
  (0, _helpers.initSVG)({
    el: 'img.svg',
    target: 'svg'
  });

  (0, _tooltips.initTooltips)();

  $('.wh-text-trim').each(function (index, element) {
    $(element).dotdotdot({
      watch: 'window'
    });
  });

  // Videos
  if ($('.wh-video-trigger').length) {
    new _VideoModal2.default($('.wh-video-trigger'), {
      template: __webpack_require__(602),
      autoPlay: true
    });
  }

  if ($('.wh-excerpts-trigger').length) {
    new _ExcerptsModal2.default($('.wh-excerpts-trigger'), {
      template: __webpack_require__(603),
      endpoint: _constants.ENDPOINT.getExcerpts
    });
  }

  // Email Disclaimer
  new _EmailDisclaimerModal2.default($('body'));

  // In the case of the right sticky rail there are 2 .col-30 in the page
  $('.col-30').each(function (index, element) {
    if ($(element).children().length === 0) {
      $(element).remove();
    } else {
      // Sticky Right Rail
      // In this case the .wh-sticky__wrapper and col-30--bottom' will always exists, so we check if
      // they don't have any children and if that's the case we remove the entire .col-30
      if ($(element).find('.wh-sticky__wrapper').length && $(element).find('.col-30--bottom')) {
        if ($(element).find('.wh-sticky__wrapper').children().length === 0 && $(element).find('.col-30--bottom').children().length === 0) {
          $(element).remove();
        }
      }
    }
  });

  new _Header2.default('.wh-header', {
    endpoint: _constants.ENDPOINT.getHeaderKeywordSearch,
    PredictiveSearch: __webpack_require__(138).default,
    triggerElement: $('.wh-home-page-hero__logo')
  });

  new _CookieUseDisclaimer2.default('.wh-cookie-use-disclaimer', {
    endpoint: _constants.ENDPOINT.setUseDisclaimerCookie
  });

  //Cookie Control
  if (window.localStorage.getItem('whCCDate') === null) {
    window.localStorage.setItem('whCCDate', new Date().getTime());
  }

  if (window.ccUpdatedDate && window.localStorage.getItem('whCCDate') && window.CookieControl) {
    var ccUpdate = new Date(window.ccUpdatedDate);
    var ccSeenDate = new Date(window.localStorage.getItem('whCCDate') * 1);
    if (ccUpdate.getTime() > ccSeenDate.getTime()) {
      window.CookieControl.open();
      window.localStorage.setItem('whCCDate', new Date(window.ccUpdatedDate).getTime());
    }
  }
}

exports.default = global;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = "<div class=wh-insights-search-results-item> <div class=wh-insights-search-results-item__wrapper data-link=\"<%= Link.Src %>\"> <% if(Image) { %> <div class=wh-insights-search-results-item__image style=\"background-image:url(<%= Image.Src %>)\"></div> <% } %> <div class=wh-insights-search-results-item__content> <div class=wh-insights-search-results-item__top> <ul class=wh-insights-search-results-item__types> <% if(SubTypes !== null && SubTypes.length > 0) { %> <% for (let i = 0; i < SubTypes.length; i++) { %> <li class=\"wh-insights-listing-result__types-item wh-insights-listing-result__types-item--type\"> <span><%= SubTypes[i].Title %></span> </li> <% }; %> <% }; %> </ul> <span class=wh-insights-search-results-item__date><%= Date %></span> </div> <h3 class=wh-insights-search-results-item__title> <% if(Link.Src) { %> <a href=\"<%= Link.Src %>\" title=\"<%= Link.Alt %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <div class=wh-insights-search-results-item__description> <div><%= Description %></div> </div> <% if(PDF.Link && PDF.Title) { %> <a href=\"<%= PDF.Link %>\" class=wh-insights-search-results-item__pdf><%= PDF.Title %></a> <% } %> </div> </div> </div> ";

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_PREFIX = '/api/sitecore';

//-- Endpoints
var ENDPOINT = exports.ENDPOINT = {
  //-- GET
  getKeywordSearch: API_PREFIX + '/mainsearch/predictive',
  getSearchResults: API_PREFIX + '/mainsearch/list/',
  getSearchResultsTabs: API_PREFIX + '/mainsearch/showsearchresultstab/',
  getBioKeywordSearch: API_PREFIX + '/bio/predictivesearch/',
  getPeopleSearchResults: API_PREFIX + '/bio/people/',
  getInsightsSearchResults: API_PREFIX + '/insights/list/',
  getInsightsPredictive: API_PREFIX + '/insights/predictive/',
  getEventsPredictive: API_PREFIX + '/insights/predictive/',
  getEventsListing: API_PREFIX + '/insights/list/',
  getNewsPredictive: API_PREFIX + '/insights/predictive/',
  getNewsListing: API_PREFIX + '/insights/list/',
  getInsightsListing: API_PREFIX + '/insights/list/',
  getInsightsListingVisibility: API_PREFIX + '/insightlisting/insightlistingtabsvisibility/',
  getExcerpts: API_PREFIX + '/book/getexcerpts/',
  getJobListing: API_PREFIX + '/job/joblisting/',
  getBlogListing: API_PREFIX + '/blogs/bloglisting',
  getContactListing: API_PREFIX + '/contactlisting/',
  getPdfPage: API_PREFIX + '/getpdfpage/',

  //-- POST
  setUseDisclaimerCookie: API_PREFIX + '/cookie/setdisclaimercookie/'
};
//-- DONT CHANGE THE ORDER OF THIS
var SEARCH_GROUPS = exports.SEARCH_GROUPS = ['featured', 'people', 'solution', 'insight', 'news', 'event', 'about', 'career', 'blog', 'video'];
var EVENTS_SEARCH_GROUPS = exports.EVENTS_SEARCH_GROUPS = ['firm-event', 'speaking-engagement', 'sponsorship'];
var NEWS_SEARCH_GROUPS = exports.NEWS_SEARCH_GROUPS = ['attorney-news', 'client-news', 'firm-news', 'community-service-news', 'recognition'];
var INSIGHTS_SEARCH_GROUPS = exports.INSIGHTS_SEARCH_GROUPS = ['client-alert', 'publication', 'blog', 'blog-landing', 'video', 'podcast'];
var GA_SEARCH_EVENTS = exports.GA_SEARCH_EVENTS = {
  Success: 'Search_success',
  Fail: 'Search_Fail',
  GeographicReach: 'Geographic_reach'
};

/***/ })

},[279]);


// WEBPACK FOOTER //
// main.bundle.js